import React from 'react'
import { StyledFooter } from './footer'

export const Footer = () => {
  return (
    <StyledFooter>
        <p>Saúde para Todos - All rights reserved</p>
    </StyledFooter>
  )
}

